import { v4 as uuid } from 'uuid'
import {
  types,
  IModelType,
  ISimpleType,
  IOptionalIType,
  IType,
  IMaybe,
  _CustomJoin,
  _NotCustomized,
  getRoot,
  unprotect
} from 'mobx-state-tree'
import { Typename } from 'src/constants/typenames'
import { fromGlobalId, toGlobalId } from 'src/api/utils/globalId'
import { ReferencePoint } from 'src/constants/referencePoints'
import { Side } from 'src/constants/sides'
import { RouteState } from 'src/constants/routes'
import { NodeComponent } from '../Node/Component'
import { INodeComponentOther } from '../Node/types'
import { withPerception } from 'src/api/misc/Perception'
import { IPerceptionOther } from 'src/api/misc/Perception/types'
import { NodeConnectedComponent } from '../Node/ConnectedComponent'

export const generateId = (type: Typename) => toGlobalId(type, uuid())

const DateModel = types.Date

// const generateBaseWithTypename = <name extends Typename = Typename>(
//   type: name
// ) => {
//   return types.model(type).props({
//     id: types.optional(
//       types.refinement(
//         types.identifier,
//         (id) => fromGlobalId(id).type === type
//       ),
//       () => toGlobalId(type, uuid())
//     ),
//     __typename: types.optional(types.literal(type), type),
//     createdAt: types.optional(DateModel, () => new Date().valueOf()),
//     updatedAt: types.optional(types.maybeNull(DateModel), null),
//     removedAt: types.maybe(DateModel),
//     restoredAt: types.maybe(DateModel)
//   })
// }

type NodeProps<N extends Typename> = {
  id: IOptionalIType<ISimpleType<string>, [undefined]>
  __typename: IOptionalIType<ISimpleType<N>, [undefined]>
  createdAt: IOptionalIType<IType<number | Date, number, Date>, [undefined]>
  updatedAt: IMaybe<IType<number | Date, number, Date>>
  removedAt: IMaybe<IType<number | Date, number, Date>>
  restoredAt: IMaybe<IType<number | Date, number, Date>>
}

export type FocusOptions = {
  side?: Side
  referencePoint: ReferencePoint
}

// type NodeComponentProps = {
//   routeState: RouteState
//   focused: boolean
//   focusedReferencePoint: ReferencePoint | null
//   focusedSide: Side | null
//   focus: (options?: Partial<FocusOptions>) => void
//   focusReferencePoint: (options: FocusOptions) => void
//   blur: () => void
// }

// export const NodeComponent = types
//   .model()
//   .volatile(self => ({
//     focused: false as boolean,
//     focusedReferencePoint: null as ReferencePoint | null,
//     focusedSide: null as Side | null
//   }))
//   .actions(self => ({
//     focusReferencePoint(options: FocusOptions) {
//       self.focusedReferencePoint = options.referencePoint
//       if (options.side) self.focusedSide = options.side
//     },
//     focus(options?: Partial<FocusOptions>) {
//       if (options) {
//         if (options.referencePoint) self.focusedReferencePoint = options.referencePoint
//         if (options.side) self.focusedSide = options.side
//       }
//       self.focused = true
//     },
//     blur() {
//       self.focused = false
//       self.focusedSide = null
//       self.focusedReferencePoint = null
//     }
//   }))

interface GenerateNodeType {
  <N extends Typename>(type: N): IModelType<
    NodeProps<N>,
    INodeComponentOther & IPerceptionOther
  >
}

export const generateNodeType: GenerateNodeType = (type) => {
  return withPerception(
    NodeComponent.named(type)
      .props({
        id: types.optional(
          types.refinement(
            types.identifier,
            (id) => fromGlobalId(id).type === type
          ),
          () => toGlobalId(type, uuid())
        ),
        __typename: types.optional(types.literal(type), type),
        createdAt: types.optional(DateModel, () => new Date().valueOf()),
        updatedAt: types.maybe(DateModel),
        removedAt: types.maybe(DateModel),
        restoredAt: types.maybe(DateModel)
      })
  )
  // .actions(self => ({
  //   ...['UpdatedAt','RemovedAt','RestoredAt'].reduce((p,c) => ({...p,[`set${c}`]: }))
  // }))s
  // .views(self => {
  //   const root = getRoot(self)
  //   return {
  //     get routeState() {
  //       return (root as $FixMe).routeState as RouteState
  //     }
  //   }
  // })
}

export const generateType = <name extends Typename = Typename>(
  type: name,
  model = types.model({})
) =>
  withPerception(
    types.compose(
      type,
      NodeConnectedComponent,
      model.props({
        __typename: types.optional(types.literal(type), type)
      })
    )
  )
